module.exports = __webpack_public_path__ + "static/media/bifoldDoor180.9bce191d.png";